module.exports = __webpack_public_path__ + "static/media/logo.e76e6b33.jpg";